<template>
	<v-container>
	</v-container>

</template>

<script>
export default {
	name: "PageFooter",
	data: () => ({

	}),
	methods: {

	},
};
</script>

<style scoped>
.keep-spaces {
	white-space: pre-wrap;
}
</style>
